export const useExpressPaymentFeatures = () => {
  const $feature = useFeatureFlags()
  const user = useUserStore()
  const cart = useCartStore()

  const features = [
    'allowApplePayOrderOnCart',
    'allowApplePayOrderOnCartWithBopis',
    'allowApplePayOrderOnPDP',
    'allowApplePayOrderOnPDPWithBopis',
    'allowExpressCheckoutWithDefaults',
    'allowPayPalOrderOnCart',
    'allowPayPalOrderOnCartWithBopis',
    'showShopPayOnCart',
    'showExpressCheckoutButtonExpander',
    'showExpressPaymentCtasInMinicart',
    'showExpressPaymentCtasInQuickshop'
  ] as const

  return features.reduce((acc, feature) => {
    acc[feature] = computed(
      () => (
        $feature[feature]
        && !(!!user.creditedConsumerProfileType || user.isAthleteProfile) && !cart.primeShippingSelected
      )
    )
    return acc
  }, {} as Record<typeof features[number], Ref<boolean>>)
}
